import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { DxSelectBoxComponent } from "devextreme-angular";

@Component({
    selector: 'h2-forecast-filters',
    styleUrls: ['./h2-forecast-filters.component.scss'],
    templateUrl: './h2-forecast-filters.component.html',
})

export class H2ForecastFiltersComponent {
    @Output() viewReport = new EventEmitter<any>();
    @Output() showAddlData = new EventEmitter<boolean>();
    @Input() regionDataSource: any;
    @Input() dataSource: any;
    @Input() showAdditionalDataSwitch: boolean = false;
    selectedRegion: string;
    countryDataSource: any;
    selectedCountries: any;
    provinceDataSource: any;
    selectedProvinces: any;
    cityDataSource: any;
    selectedCities: any;
    maxFilterQueryLength: number = 60000;
    estimatedAwardYearDataSource: any;
    selectEdestimatedAwardYear: any;
    forecastDriverDataSource: any;
    selectForecastDriver: any;
    businessModelDataSource: any;
    selectBusinessModel: any;
    reportDataSource: any;
    includeAdditionalData: boolean = false;
    allRegion: string = "All";

    @ViewChild("regions", { static: false }) regions: DxSelectBoxComponent;

    getReports() {
        if (this.selectedRegion && this.selectedCountries && this.selectedCountries.length > 0 && this.selectedProvinces && this.selectedProvinces.length > 0
            && this.selectedCities && this.selectedCities.length > 0 && this.selectEdestimatedAwardYear && this.selectEdestimatedAwardYear.length > 0 && this.selectForecastDriver && this.selectForecastDriver.length > 0 && this.selectBusinessModel && this.selectBusinessModel.length > 0) {
            this.reportDataSource = this.dataSource.filter((item) => this.selectedCountries.indexOf(item.countryName) >= 0 
            && this.selectedProvinces.indexOf(item.province) >= 0
                && this.selectedCities.indexOf(item.city) >= 0 
                && this.selectEdestimatedAwardYear.indexOf(item.estimatedAwardYear) >= 0 
                && this.selectForecastDriver.indexOf(item.forecastDriver) >= 0 
                && this.selectBusinessModel.indexOf(item.businessModel) >= 0);
            this.viewReport.emit(this.reportDataSource);
            this.showAddlData.emit(this.includeAdditionalData);
        } else if (!(this.selectedRegion)) {
            this.regions.validationStatus = "invalid"
        }
    }

    onRegionChanged(e) {
        if (e.value.length > 0) {
            this.countryDataSource = this.dataSource.filter((item) => e.value.some((val)=> val === item.hycoRegions)).map((item) => item.countryName).filter((value, index, self) => self.indexOf(value) === index).sort();
            this.selectedCountries = this.countryDataSource;
        }
    }

    onCountryChanged(e) {
        if (e.value.length > 0) {
            this.provinceDataSource = this.dataSource.filter((item) => e.value.indexOf(item.countryName) >= 0).map((item) => item.province).filter((value, index, self) => self.indexOf(value) === index).sort();
            this.selectedProvinces = this.provinceDataSource;
        }
    }

    onProvinceChanged(e) {
        if (e.value.length > 0) {
            this.cityDataSource = this.dataSource.filter((item) => e.value.indexOf(item.province) >= 0).map((item) => item.city).filter((value, index, self) => self.indexOf(value) === index).sort();
            this.selectedCities = this.cityDataSource;
        }
    }

    onCityChanged(e) {
        this.estimatedAwardYearDataSource = this.dataSource.filter((item) => this.selectedCountries.indexOf(item.countryName) >= 0 && this.selectedProvinces.indexOf(item.province) >= 0
            && this.selectedCities.indexOf(item.city) >= 0).map((item) => item.estimatedAwardYear).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.selectEdestimatedAwardYear = this.estimatedAwardYearDataSource;

        this.forecastDriverDataSource = this.dataSource.filter((item) => this.selectedCountries.indexOf(item.countryName) >= 0 && this.selectedProvinces.indexOf(item.province) >= 0
            && this.selectedCities.indexOf(item.city) >= 0).map((item) => item.forecastDriver).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.selectForecastDriver = this.forecastDriverDataSource;

        this.businessModelDataSource = this.dataSource.filter((item) => this.selectedCountries.indexOf(item.countryName) >= 0 && this.selectedProvinces.indexOf(item.province) >= 0
            && this.selectedCities.indexOf(item.city) >= 0).map((item) => item.businessModel).filter((value, index, self) => self.indexOf(value) === index).sort();
        this.selectBusinessModel = this.businessModelDataSource;
    }
}